import * as XLSX from 'xlsx';
//it will detect those column which have value
export const ExtractExcelFileData = (file: File): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Convert sheet to JSON array
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        resolve(jsonData);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsArrayBuffer(file);
  });
};
//it will detect all columns
export const ExtractExcelFileData1 = (
  file: File
): Promise<{ headers: string[]; data: any[] }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (!Array.isArray(jsonData) || jsonData.length === 0) {
          return resolve({ headers: [], data: [] });
        }

        // First row is headers
        const rawHeaders = Array.isArray(jsonData[0]) ? jsonData[0] : [];
        const cleanedHeaders: string[] = rawHeaders
          .map((h: string | undefined) => (h ?? "").trim())
          .filter((h: string) => h.length > 0);

        // Build array of objects regardless of input shape
        const dataWithoutHeaders = jsonData.slice(1).map((row: any) => {
          const obj: any = {};
          cleanedHeaders.forEach((header, index) => {
            // Handle both array rows and object rows gracefully
            if (Array.isArray(row)) {
              obj[header] = row[index] ?? null;
            } else if (row && typeof row === "object") {
              obj[header] = row[rawHeaders[index]] ?? null;
            } else {
              obj[header] = null;
            }
          });
          return obj;
        });

        resolve({
          headers: cleanedHeaders,
          data: dataWithoutHeaders,
        });
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};





